var FIGURE = FIGURE || {};

// Disables headroom.js (initialized unconditionally by OffsetBaseResources/js/site.js).
// The delay must exceed headroom's own 100ms deferred attachEvent() call, or it
// re-attaches its scroll listener right after we destroy it.
setTimeout(function () {
	$("body").headroom("destroy");
}, 150);


FIGURE.shippingMessage = function () {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function () {
			$('#figureMessageModal').modal();
		}, 3000);
	}
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function () {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

var FIGURE = FIGURE || {};

/**
 * Offering Quantity Update with Conditions
 * Requires updates to cart-quantity-add file:
 * Change select classes of qty and wish-qty to offering-qty and wish-offering-qty respectively
 */

FIGURE.newOfferingUpdateQuantity = function() {
	if ($(".page-offering-index").length) {
		// Cache for offering conditions - only fetched once
		let cachedConditions = null;
		let conditionsFetched = false;

		function debounce(func, wait) {
			let timeout;
			return function executedFunction(...args) {
				const later = () => {
					clearTimeout(timeout);
					func.apply(this, args);
				};
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
			};
		}

		// Fetch conditions once and cache
		async function getOfferingConditions() {
			if (conditionsFetched) {
				return cachedConditions;
			}

			const page = getPage();
			try {
				const res = await fetch(`/${page}/offering_conditions/`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					}
				});
				const data = await res.json();

				if (data && data.group_id && data.conditions) {
					// Get conditions for this group ID
					const groupId = data.group_id;
					cachedConditions = {
						groupId: groupId,
						cart: data.cart,
						conditions: data.conditions[groupId] || []
					};
				} else {
					cachedConditions = {
						groupId: null,
						cart: {},
						conditions: []
					};
				}

				conditionsFetched = true;
				return cachedConditions;
			} catch (error) {
				console.error('Error fetching offering conditions:', error);
				conditionsFetched = true;
				cachedConditions = { groupId: null, cart: {}, conditions: [] };
				return cachedConditions;
			}
		}

		// Get fresh cart data (cart changes, conditions don't)
		async function getCartData() {
			const page = getPage();
			try {
				const res = await fetch(`/${page}/get_offering_cart/`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					}
				});
				const data = await res.json();
				return data.cart || {};
			} catch (error) {
				console.error('Error fetching cart data:', error);
				return {};
			}
		}

		$(".offering-qty").on("change", debounce(async function () {
			var selector = $(this).attr("id");
			var parts = selector.split("qty-");
			var id = parts[1];
			var val = $(this).val();
			await checkConditions(id, val);
		}, 250));

		// Wish Quantity Selector
		$(".wish-offering-qty").bind("change", debounce(async function () {
			var parts = $(this).attr("id").split("qty-");
			var id = parts[1];
			var val = $(this).val();
			await checkWishConditions(id, val);
		}, 250));

		async function checkConditions(id, val) {
			try {
				// Get cached conditions (fetches once if not cached)
				const offeringData = await getOfferingConditions();
				const conditions = offeringData.conditions;

				// Cart needs to be fresh since it changes
				const cartData = await getCartData();
				const cart = cartData.items || {};

				let conditional = false;
				let overrideWish = false;
				const value = parseInt(val) || 0;

				if (conditions && conditions.length) {
					conditions.forEach(condition => {
						const rule = condition.rule;

						if (rule === "min_purchase_access") {
							const required = condition.required;
							const dependent = condition.dependent;

							if (required.some(req => req.sku === id)) {
								conditional = true;
								const maxConditionQty = required.find(req => req.sku === id).quantity;
								dependent.forEach(dep => {
									const depSku = dep.sku;
									const $depQtyInput = $(`#qty-${depSku}`);

									updateOfferingQuantity(id, value);
									checkWishRequests(id, value);

									if (value >= maxConditionQty) {
										$depQtyInput.prop("disabled", false);
									} else {
										$depQtyInput.val(0);
										updateOfferingQuantity(depSku, 0);
										$depQtyInput.prop("disabled", true);

										// Also hide and reset the dependent's wish
										const $depWishWrapper = $(`.wishwrapper-${depSku}`);
										const $depWishQtyInput = $(`#wishqty-${depSku}`);
										$depWishWrapper.hide();
										$depWishQtyInput.val($depWishQtyInput.find("option:first").val());
										updateWishQuantity(depSku, 0);
									}
								});
							}
						}

						if (rule === "max_purchase_group") {
							const dependent = condition.dependent;

							if (dependent.some(dep => dep.sku === id)) {
								const quantity = condition.quantity;

								// Find SKUs that are disabled by min_purchase_access rules
								const disabledByMinAccess = new Set();
								conditions.forEach(otherCondition => {
									if (otherCondition.rule === "min_purchase_access") {
										const required = otherCondition.required;
										const minDependent = otherCondition.dependent;

										let thresholdMet = true;
										required.forEach(req => {
											const $reqInput = $(`#qty-${req.sku}`);
											let reqQty;
											if (req.sku === id) {
												reqQty = value;
											} else {
												reqQty = parseInt($reqInput.val()) || 0;
											}
											if (reqQty < req.quantity) {
												thresholdMet = false;
											}
										});

										if (!thresholdMet) {
											minDependent.forEach(dep => {
												disabledByMinAccess.add(dep.sku);
											});
										}
									}
								});

								// Find any protected minimums from min_purchase_access rules
								const protectedMins = {};
								conditions.forEach(otherCondition => {
									if (otherCondition.rule === "min_purchase_access") {
										otherCondition.required.forEach(req => {
											if (dependent.some(dep => dep.sku === req.sku)) {
												const $reqInput = $(`#qty-${req.sku}`);
												const currentQty = req.sku === id ? value : (parseInt($reqInput.val()) || 0);
												if (currentQty >= req.quantity) {
													protectedMins[req.sku] = req.quantity;
												}
											}
										});
									}
								});

								// Get total quantity of all dependent SKUs including current change
								let dependentCartQty = 0;
								dependent.forEach(dep => {
									const depSku = dep.sku;
									if (depSku === id) {
										dependentCartQty += value || 0;
									} else if (cart[depSku]) {
										dependentCartQty += parseInt(cart[depSku].quantity) || 0;
									}
								});

								// Build final state first, then apply all at once
								const finalState = {};
								let newTotal = value;
								finalState[id] = value;

								if (dependentCartQty > quantity) {
									dependent.forEach(dep => {
										const depSku = dep.sku;
										if (depSku !== id) {
											const options = [];
											$(`#qty-${depSku} option`).each(function() {
												options.push(parseInt($(this).val()));
											});
											options.sort((a, b) => b - a);

											const minRequired = protectedMins[depSku] || 0;

											let found = false;
											for (const option of options) {
												if (newTotal + option <= quantity && option >= minRequired) {
													newTotal += option;
													finalState[depSku] = option;
													found = true;
													break;
												}
											}
											if (!found) {
												finalState[depSku] = minRequired;
												newTotal += minRequired;
											}
										}
									});

									if (protectedMins[id] && value < protectedMins[id]) {
										$(`#qty-${id}`).val(protectedMins[id]);
										finalState[id] = protectedMins[id];
										return;
									}

								} else {
									dependent.forEach(dep => {
										const depSku = dep.sku;
										if (depSku !== id) {
											const $depQtyInput = $(`#qty-${depSku}`);
											finalState[depSku] = parseInt($depQtyInput.val()) || 0;
										}
									});
								}

								const finalTotal = Object.values(finalState).reduce((sum, q) => sum + q, 0);
								const maxMet = finalTotal >= quantity;

								overrideWish = true;
								dependent.forEach(dep => {
									const depSku = dep.sku;
									const $depQtyInput = $(`#qty-${depSku}`);
									const finalQty = finalState[depSku];

									if (depSku !== id && finalQty !== parseInt($depQtyInput.val())) {
										$depQtyInput.val(finalQty);
										updateOfferingQuantity(depSku, finalQty);
									}

									const $wishWrapper = $(`.wishwrapper-${depSku}`);
									const $wishQtyInput = $(`#wishqty-${depSku}`);
									const isAlreadyVisible = $wishWrapper.is(":visible");

									if (maxMet) {
										$wishWrapper.show();
										// if (!isAlreadyVisible) {
										// 	updateWishQuantity(depSku, finalQty);
										// }
									} else {
										$wishWrapper.hide();
										$wishQtyInput.val($wishQtyInput.find("option:first").val());
										updateWishQuantity(depSku, 0);
									}
								});

								// Only disable options if there's a min_purchase_access rule that overlaps
								const hasMinAccessOverlap = Object.keys(protectedMins).length > 0;

								if (hasMinAccessOverlap) {
									dependent.forEach(dep => {
										const depSku = dep.sku;

										if (disabledByMinAccess.has(depSku)) {
											return;
										}

										if (depSku !== id && !protectedMins[depSku]) {
											const currentOthersTotal = Object.entries(finalState)
												.filter(([sku]) => sku !== depSku)
												.reduce((sum, [, qty]) => sum + qty, 0);

											const maxAllowedForThis = quantity - currentOthersTotal;

											$(`#qty-${depSku} option`).each(function() {
												const optVal = parseInt($(this).val());
												if (optVal > maxAllowedForThis && optVal > 0) {
													$(this).prop('disabled', true);
												} else {
													$(this).prop('disabled', false);
												}
											});
										}
									});
								}
							}
						}
					});
				}

				if (!conditional) {
					updateOfferingQuantity(id, val);
				}
				if (!overrideWish) {
					checkWishRequests(id, val);
				}

			} catch (error) {
				console.error('Error checking conditions:', error);
			}
		}

		async function checkWishConditions(id, val) {
			try {
				const offeringData = await getOfferingConditions();
				const conditions = offeringData.conditions;
				const value = parseInt(val) || 0;

				let hasGroupMax = false;

				if (conditions && conditions.length) {
					conditions.forEach(condition => {
						const rule = condition.rule;

						if (rule === "max_purchase_group") {
							const dependent = condition.dependent;

							if (dependent.some(dep => dep.sku === id)) {
								hasGroupMax = true;
								const quantity = condition.quantity;

								let purchaseTotal = 0;
								dependent.forEach(dep => {
									const depSku = dep.sku;
									const $depQtyInput = $(`#qty-${depSku}`);
									purchaseTotal += parseInt($depQtyInput.val()) || 0;
								});

								let wishTotal = 0;
								dependent.forEach(dep => {
									const depSku = dep.sku;
									const $wishQtyInput = $(`#wishqty-${depSku}`);
									if (depSku === id) {
										wishTotal += value;
									} else {
										wishTotal += parseInt($wishQtyInput.val()) || 0;
									}
								});

								if (wishTotal > quantity) {
									const finalWishState = {};
									let newTotal = value;
									finalWishState[id] = value;

									dependent.forEach(dep => {
										const depSku = dep.sku;
										if (depSku !== id) {
											const options = [];
											$(`#wishqty-${depSku} option`).each(function() {
												options.push(parseInt($(this).val()));
											});
											options.sort((a, b) => b - a);

											let found = false;
											for (const option of options) {
												if (newTotal + option <= quantity) {
													newTotal += option;
													finalWishState[depSku] = option;
													found = true;
													break;
												}
											}
											if (!found) {
												finalWishState[depSku] = 0;
											}
										}
									});

									dependent.forEach(dep => {
										const depSku = dep.sku;
										const $wishQtyInput = $(`#wishqty-${depSku}`);
										const finalQty = finalWishState[depSku];

										if (finalQty !== parseInt($wishQtyInput.val())) {
											$wishQtyInput.val(finalQty);
										}
										updateWishQuantity(depSku, finalQty);
									});
								} else {
									updateWishQuantity(id, value);
								}
							}
						}
					});
				}

				if (!hasGroupMax) {
					updateWishQuantity(id, val);
				}

			} catch (error) {
				console.error('Error checking wish conditions:', error);
			}
		}

		async function updateOfferingQuantity(id, value) {
			if (value <= 0) {
				value = "0";
			}

			var page = getPage();
			try {
				const quantityRes = await fetch("/" + page + "/update_quantity/" + id + "/" + value + "/", {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					}
				});
				const data = await quantityRes.json();

				updateDisplay("item_count_display", data.quantity);
				updateDisplay("js-item_count_display", data.quantity);
				updateDisplay("subtotal_display", data.subtotal.toFixed(2));
				updateDisplay("js-subtotal_display", data.subtotal.toFixed(2));
				updateDisplay("subtotal_display_2", data.subtotal.toFixed(2));
				updateDisplay("js-subtotal_display_2", data.subtotal.toFixed(2));
				updateDisplay("shipping_display", data.shipping.toFixed(2));
				updateDisplay("js-shipping_display", data.shipping.toFixed(2));
				if (data.crv) updateDisplay("crv_display", data.crv.toFixed(2));
				updateDisplay("discount_display", data.discount.toFixed(2));
				updateDisplay("tax_display", data.tax.toFixed(2));
				updateDisplay("total_display_alt", data.total.toFixed(2));
				updateDisplay("total_display", data.total.toFixed(2));

				if ($(".add-your-full-allocation").length) {
					if (data.allocation_remaining === true) {
						$(".add-your-full-allocation").show();
					} else {
						$(".add-your-full-allocation").hide();
					}
				}
				if (data.quantity > 0) {
					$("#cartcount").html(
						" <span class='badge badge-pill badge-primary'>" +
						data.quantity +
						"</span>"
					);
					$("#cartcountnav").html(
						" <span class='badge badge-pill badge-primary'>" +
						data.quantity +
						"</span>"
					);
					$(".cart-link").removeClass("hide-cart");
				} else {
					$("#cartcount").html("");
					$("#cartcountnav").html("");
					$(".cart-link").addClass("hide-cart");
				}
				if (data.expires > 0) {
					var totalSecs = data.expires;
					var secondz = totalSecs * 1000;
					if (secondz > 0) {
						window.setTimeout(function () {
							location.href = "/offering/expired/";
						}, secondz);
					}
				}
				if (data.quantity < 6) {
					$(".cart-shipping-message").removeClass("blank");
					$(".more-bottles").removeClass("no-more");
					$("#moar").html(6 - data.quantity);
					$(".qualified").removeClass("success");
					if (data.quantity == 5) {
						$("#plural").hide();
					} else {
						$("#plural").show();
					}
				} else {
					$(".cart-shipping-message").removeClass("blank");
					$(".more-bottles").addClass("no-more");
					$(".qualified").addClass("success");
				}
				$("#secure-checkout-update-cart").hide();
				if (data) {
					const isDiscounted = $("#enable_product_volume_discounts").val();
					if (isDiscounted === "TRUE") {
						updateDiscountPrice();
					}
				}
			} catch(error) {
				console.error('Error updating quantity:', error);
			}
		}

		function updateDisplay(id, value) {
			const $objClass = $("." + id);
			const $obj = $("#" + id);

			if (value > 0) {
				value = addCommas(value);
				$obj.html(value);
				$objClass.html(value);
			} else {
				$obj.html("0");
				$objClass.html("0");
			}
		}

		function updateDiscountPrice() {
			$.getJSON("/cart/get_items", function (data) {
				$.each(data, function (i, item) {
					var theID = "#Price_" + item.sku;
					var theVolID = "#Vol_" + item.sku;
					$(theID).html(item.price);
					if (item.has_volume_discount == 1) {
						$(theVolID).fadeIn();
					} else {
						$(theVolID).fadeOut();
					}
				});
			});
		}

		function checkWishRequests(id, quant, groupMaxLimit = null, groupMaxTotal = null) {
			const $wishWrapper = $(".wishwrapper-" + id);
			const $wishQtyInput = $("#wishqty-" + id);
			const isAlreadyVisible = $wishWrapper.is(":visible");

			if (groupMaxLimit) {
				if (groupMaxLimit <= groupMaxTotal) {
					$wishWrapper.show();
					if (!isAlreadyVisible) {
						updateWishQuantity(id, quant);
					}
				} else {
					$wishWrapper.hide();
					$wishQtyInput.val($wishQtyInput.find("option:first").val());
					updateWishQuantity(id, 0);
				}
			} else {
				const max = $("#qty-" + id + " option:last-child").val();

				if (quant == max) {
					$wishWrapper.show();
				}
				if (parseInt(quant) < parseInt(max)) {
					$wishWrapper.hide();
					$wishQtyInput.val($wishQtyInput.find("option:first").val());
					updateWishQuantity(id, 0);
				}
			}
		}

		function updateWishQuantity(id, value) {
			if (value < 0) {
				value = 0;
			}
			$.getJSON(
				"/offering/update_wishlist/" + id + "/" + value + "/",
				function (data) {}
			);
		}

		function getPage() {
			var $parts = window.location.pathname;
			$parts = $parts.split("/");
			return $parts[1];
		}

		function addCommas(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	}
}();

